import React, { useEffect, useState } from "react";
import { onSnapshot} from "firebase/firestore";
import { db } from "../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { useLocation } from "react-router-dom";

const ResultUpdate = () => {
    const location = useLocation();
    const [studentResultDetails, setStudentResultDetails] = useState([]);

  const [perTestExamEnglishTerm1,setPerTestExamEnglishTerm1] = useState("");
  const [noteBookEnglishTerm1,setNoteBookEnglishTerm1] = useState("");
  const [subjectEnrichmentEnglishTerm1,setSubjectEnrichmentEnglishTerm1] = useState("");
  const [halfYearlyExamEnglishTerm1,setHalfYearlyExamEnglishTerm1] = useState("");

  const [perTestExamHindiTerm1,setPerTestExamHindiTerm1] = useState("");
  const [noteBookHindiTerm1,setNoteBookHindiTerm1] = useState("");
  const [subjectEnrichmentHindiTerm1,setSubjectEnrichmentHindiTerm1] = useState("");
  const [halfYearlyExamHindiTerm1,setHalfYearlyExamHindiTerm1] = useState("");

  
  const [perTestExamScienceTerm1,setPerTestExamScienceTerm1] = useState("");
  const [noteBookScienceTerm1,setNoteBookScienceTerm1] = useState("");
  const [subjectEnrichmentScienceTerm1,setSubjectEnrichmentScienceTerm1] = useState("");
  const [halfYearlyExamScienceTerm1,setHalfYearlyExamScienceTerm1] = useState("");

  const [perTestExamMathsTerm1,setPerTestExamMathsTerm1] = useState("");
  const [noteBookMathsTerm1,setNoteBookMathsTerm1] = useState("");
  const [subjectEnrichmentMathsTerm1,setSubjectEnrichmentMathsTerm1] = useState("");
  const [halfYearlyExamMathsTerm1,setHalfYearlyExamMathsTerm1] = useState("");

  
  const [perTestExamSanskritTerm1,setPerTestExamSanskritTerm1] = useState("");
  const [noteBookSanskritTerm1,setNoteBookSanskritTerm1] = useState("");
  const [subjectEnrichmentSanskritTerm1,setSubjectEnrichmentSanskritTerm1] = useState("");
  const [halfYearlyExamSanskritTerm1,setHalfYearlyExamSanskritTerm1] = useState("");

  const [perTestExamSocialScienceTerm1,setPerTestExamSocialScienceTerm1] = useState("");
  const [noteBookSocialScienceTerm1,setNoteBookSocialScienceTerm1] = useState("");
  const [subjectEnrichmentSocialScienceTerm1,setSubjectEnrichmentSocialScienceTerm1] = useState("");
  const [halfYearlyExamSocialScienceTerm1,setHalfYearlyExamSocialScienceTerm1] = useState("");


  let totalMarksTerm1 = 600 ;

  const showGradeTerm1 = (marks)=> {
  
    if (marks < 33) {
      return "Fail"
    } else if (marks >= 33 && marks < 40) { 
      return "D"
    } else if (marks >= 40 && marks < 50) {
      return "C2"
    }else if (marks >= 50 && marks < 60) {
      return "C1"
    }else if (marks >= 60 && marks < 70) {
      return "B2"
    }else if (marks >= 70 && marks < 80) {
      return "B1"
    }else if (marks >= 80 && marks < 90) {
      return "A2"
    }else if (marks >= 90 && marks < 100) {
      return "A1"
    } else {
      return "N/A"
    }
  }

  const showTotalGradeTerm1 = (marks)=> {
    if (marks < 198) {
      return "Fail"
    } else if (marks >= 198 && marks < 240) {
      return "D"
    } else if (marks >= 240 && marks < 300) {
      return "C2"
    }else if (marks >= 300 && marks < 360) {
      return "C1"
    }else if (marks >= 360 && marks < 420) {
      return "B2"
    }else if (marks >= 420 && marks < 480) {
      return "B1"
    }else if (marks >= 480 && marks < 540) {
      return "A2"
    }else if (marks >= 540 && marks < 600) {
      return "A1"
    } else {
      return "N/A"
    }
  }


  
  let totalObtainEnglishTerm1 = parseFloat(perTestExamEnglishTerm1)+parseFloat(noteBookEnglishTerm1)+parseFloat(subjectEnrichmentEnglishTerm1)+parseFloat(halfYearlyExamEnglishTerm1); 
  let totalObtainHindiTerm1 = parseFloat(perTestExamHindiTerm1)+parseFloat(noteBookHindiTerm1)+parseFloat(subjectEnrichmentHindiTerm1)+parseFloat(halfYearlyExamHindiTerm1);
  let totalObtainMathsTerm1 = parseFloat(perTestExamMathsTerm1)+parseFloat(noteBookMathsTerm1)+parseFloat(subjectEnrichmentMathsTerm1)+parseFloat(halfYearlyExamMathsTerm1);
  let totalObtainScienceTerm1 = parseFloat(perTestExamScienceTerm1)+parseFloat(noteBookScienceTerm1)+parseFloat(subjectEnrichmentScienceTerm1)+parseFloat(halfYearlyExamScienceTerm1);
  let totalObtainSanskritTerm1 = parseFloat(perTestExamSanskritTerm1)+parseFloat(noteBookSanskritTerm1)+parseFloat(subjectEnrichmentSanskritTerm1)+parseFloat(halfYearlyExamSanskritTerm1);
  let totalObtainSocialScienceTerm1 = parseFloat(perTestExamSocialScienceTerm1)+parseFloat(noteBookSocialScienceTerm1)+parseFloat(subjectEnrichmentSocialScienceTerm1)+parseFloat(halfYearlyExamSocialScienceTerm1);

  let totalObtainedMarksTerm1 = parseFloat(totalObtainEnglishTerm1) + parseFloat(totalObtainHindiTerm1) + parseFloat(totalObtainMathsTerm1) + parseFloat(totalObtainScienceTerm1) + parseFloat(totalObtainSanskritTerm1) + parseFloat(totalObtainSocialScienceTerm1);
  let percentageTerm1 = (totalObtainedMarksTerm1 / totalMarksTerm1) * 100 ;

  
  useEffect(() => {
    onSnapshot(doc(db, "resultStudent", location.state.resultId), (doc) => {
        let array=[]
        array.push({id:doc.id,...doc.data()})
        setStudentResultDetails(array);
    });
    }, []);

  const updateResultField = async () => {
    await updateDoc(doc(db, "resultStudent", location.state.resultId), {
      perTestExamEnglishTerm1,
      noteBookEnglishTerm1,
      subjectEnrichmentEnglishTerm1,
      halfYearlyExamEnglishTerm1,
      totalObtainEnglishTerm1,
      perTestExamHindiTerm1,
      noteBookHindiTerm1,
      subjectEnrichmentHindiTerm1,
      halfYearlyExamHindiTerm1,
      totalObtainHindiTerm1,
      perTestExamMathsTerm1,
      noteBookMathsTerm1,
      subjectEnrichmentMathsTerm1,
      halfYearlyExamMathsTerm1,
      totalObtainMathsTerm1,
      perTestExamSanskritTerm1,
      subjectEnrichmentSanskritTerm1,
      noteBookSanskritTerm1,
      halfYearlyExamSanskritTerm1,
      totalObtainSanskritTerm1,
      perTestExamScienceTerm1,
      noteBookScienceTerm1,
      subjectEnrichmentScienceTerm1,
      halfYearlyExamScienceTerm1,
      totalObtainScienceTerm1,
      perTestExamSocialScienceTerm1,
      noteBookSocialScienceTerm1,
      subjectEnrichmentSocialScienceTerm1,
      halfYearlyExamSocialScienceTerm1,
      totalObtainSocialScienceTerm1,
      totalMarksTerm1,
      totalObtainedMarksTerm1,
      percentageTerm1
    })?.then(() => {
      window.location.reload(false)
      // console.log("Successfully Updated");
    });
  };
  return (
    <div>
    {studentResultDetails?.map((item, index) => (
  <div>
   <div className="grid grid-cols-7 gap-4" key={index}>
  <div className='justify-self-end items-center' >
   <img src="../assets/sail.png" alt="pic" className='h-24 w-24' />
  </div>
  <div className="mb-2 text-center w-full col-span-5">
  <div className='mb-1 '> 
          <span className="font-bold  text-3xl ">
              BOKARO ISPAT SENIOR SECONDARY SCHOOL 8B
          </span>
  </div>
  <div className='grid grid-cols-9 gap-4'>
  <div className='mb-1 col-span-5 ml-10'> 
  <span className="text-xl ">
              BOKARO STEEL CITY, JHARKHAND (INDIA)
           </span>
  </div>
  </div>  
  <div className="flex justify-center items-center mt-6 ">
        <div className="md:w-1/5 ">
          <label
            className="block font-bold md:text-left "
          >
            Academic Session
          </label>
        </div>
        <div className="md:w-1/5">
        {item.academicSession}
        </div>
      </div>
<div className='mb-1'> 
<span className="block font-bold md:text-center mb-1 md:mb-0 pr-4 text-2xl underline underline-offset-8 ">
  REPORT CARD FOR THE CLASS-VI/6B
  </span>
</div>
</div>
  <div className='justify-items-center items-center' >
   <img src="../assets/as_logo.png" alt="pic" className='h-24 w-24' />
  </div>
  </div>
  <div className="grid grid-cols-2  pl-5 pr-5 ">
          <div className="  text-black-500 text-lg font-bold text-center pt-10  ">
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Roll No.
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.classRollNumber}
                </div>
              </div>
            </div>
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6 ">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Student's Name
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.studentName}
                </div>
              </div>
            </div>
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                   Mother's Name
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.mothersName}
                </div>
              </div>
            </div>

          </div>
          <div className=" text-black-500 text-lg font-bold text-center pt-10  pl-10 ">
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Student ID
                  </label>
                </div>
                <div className="md:w-2/5">
                <div>{item.studentIdNumber}</div>
                </div>
              </div>
            </div>
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                   Date of Birth
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.dateOfBirth}                   
                </div>
              </div>
            </div>
           
            <div className="w-full max-w-sm">
              <div className="md:flex md:items-center mb-6">
                <div className="md:w-2/5">
                  <label
                    className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Father's Name
                  </label>
                </div>
                <div className="md:w-2/5">
                {item.fathersName}
                </div>
              </div>
            </div>
          </div>
    </div>
    </div>
    ))}
  <div className="mt-5">
  <div className="overflow-x-auto shadow-md sm:rounded-lg">
    <div className="text-xl text-white uppercase py-3  font-semibold bg-[#6c707b] ">
      Term-I (100 Marks)
    </div>
    <table className="min-w-full border text-center">
    <thead className="border-b ">
        <tr className="bg-gray-100">
          <th className="py-3">Subject Name</th>
          <th className="py-3">Per Test (10)</th>
          <th className="py-3">Note Book (05)</th>
          <th className="py-3">Subject Enrichment (05)</th>
          <th className="py-3">Half Yearly Exam (80)</th>
          <th className="py-3">Marks Obtained (100)</th>
          <th className="py-3">Grade</th>
        </tr>
      </thead>
      <tbody>
        <tr className="border-b">
          <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
            English
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='per '
              value={perTestExamEnglishTerm1}
              onChange={(e) => {
                setPerTestExamEnglishTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='Note'
              value={noteBookEnglishTerm1}
              onChange={(e) => {
                setNoteBookEnglishTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='enrichment'
              value={subjectEnrichmentEnglishTerm1}
              onChange={(e) => {
                setSubjectEnrichmentEnglishTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='h.y'
              value={halfYearlyExamEnglishTerm1}
              onChange={(e) => {
                setHalfYearlyExamEnglishTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
            {totalObtainEnglishTerm1}
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r" >
          {showGradeTerm1(totalObtainEnglishTerm1)}
          </td>
        
        </tr>
        <tr className="border-b">
          <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
            Hindi
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='per '
              value={perTestExamHindiTerm1}
              onChange={(e) => {
                setPerTestExamHindiTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='Note'
              value={noteBookHindiTerm1}
              onChange={(e) => {
                setNoteBookHindiTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='enrichment'
              value={subjectEnrichmentHindiTerm1}
              onChange={(e) => {
                setSubjectEnrichmentHindiTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='h.y'
              value={halfYearlyExamHindiTerm1}
              onChange={(e) => {
                setHalfYearlyExamHindiTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
            {totalObtainHindiTerm1}
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          {showGradeTerm1(totalObtainHindiTerm1)}
          </td>
        
        </tr>
        <tr className="border-b">
          <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
          Sanskrit
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='per '
              value={perTestExamSanskritTerm1}
              onChange={(e) => {
                setPerTestExamSanskritTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='Note'
              value={noteBookSanskritTerm1}
              onChange={(e) => {
                setNoteBookSanskritTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='enrichment'
              value={subjectEnrichmentSanskritTerm1}
              onChange={(e) => {
                setSubjectEnrichmentSanskritTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='h.y'
              value={halfYearlyExamSanskritTerm1}
              onChange={(e) => {
                setHalfYearlyExamSanskritTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
            {totalObtainSanskritTerm1}
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          {showGradeTerm1(totalObtainSanskritTerm1)}
          </td>
        
        </tr>
        <tr className="border-b">
          <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
            Maths
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='per '
              value={perTestExamMathsTerm1}
              onChange={(e) => {
                setPerTestExamMathsTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='Note'
              value={noteBookMathsTerm1}
              onChange={(e) => {
                setNoteBookMathsTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='enrichment'
              value={subjectEnrichmentMathsTerm1}
              onChange={(e) => {
                setSubjectEnrichmentMathsTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='h.y'
              value={halfYearlyExamMathsTerm1}
              onChange={(e) => {
                setHalfYearlyExamMathsTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
            {totalObtainMathsTerm1}
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          {showGradeTerm1(totalObtainMathsTerm1)}
          </td>
        
        </tr>
        <tr className="border-b">
          <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
            Science
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='per '
              value={perTestExamScienceTerm1}
              onChange={(e) => {
                setPerTestExamScienceTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='Note'
              value={noteBookScienceTerm1}
              onChange={(e) => {
                setNoteBookScienceTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='enrichment'
              value={subjectEnrichmentScienceTerm1}
              onChange={(e) => {
                setSubjectEnrichmentScienceTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='h.y'
              value={halfYearlyExamScienceTerm1}
              onChange={(e) => {
                setHalfYearlyExamScienceTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
            {totalObtainScienceTerm1}
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          {showGradeTerm1(totalObtainScienceTerm1)}
          </td>
        
        </tr>
        <tr className="border-b">
          <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
          S.Science
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='per '
              value={perTestExamSocialScienceTerm1}
              onChange={(e) => {
                setPerTestExamSocialScienceTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='Note'
              value={noteBookSocialScienceTerm1}
              onChange={(e) => {
                setNoteBookSocialScienceTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='enrichment'
              value={subjectEnrichmentSocialScienceTerm1}
              onChange={(e) => {
                setSubjectEnrichmentSocialScienceTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          <input
              type="text"
              className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              placeholder='h.y'
              value={halfYearlyExamSocialScienceTerm1}
              onChange={(e) => {
                setHalfYearlyExamSocialScienceTerm1(e.target.value);
              }}
            />
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
            {totalObtainSocialScienceTerm1}
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
          {showGradeTerm1(totalObtainSocialScienceTerm1)}
          </td>
        
        </tr>

      </tbody>
    </table>
    <table className="min-w-full border text-center">
      <tbody>
            <tr>
            <td className="py-2 px-3 text-sm font-medium text-gray-900 "> 
            Total Marks : {totalMarksTerm1}
          </td>
          <td className="py-2 px-1 text-sm font-medium text-gray-900 ">
            Obtained Marks : {totalObtainedMarksTerm1}
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
             PercentageTerm1 : {percentageTerm1}
          </td>
          <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
           Grade : {showTotalGradeTerm1(totalObtainedMarksTerm1)}
          </td>
            </tr>
      </tbody>
    </table>
  </div>
  <div className="mt-10">
      <button
        className="text-white bg-green-600 py-1 px-1 rounded-md "
        onClick={updateResultField}
      >
        Update
      </button>
    </div>
</div>
</div>
  )
}

export default ResultUpdate